
export class OwnersForm {
    id: number;
    companyName: string;
    firstName: string;
    lastName: string;
    phone: string;
    phoneTimeToCall: string;
    mobile: string;
    mobileTimeToCall: string;
    email: string;
    optedIn: string;
    deleted: boolean;
    userId: number;
    isChangedOwnerShip: boolean;
    assignedTo: {
        id: number,
        userName: string,
        firstName: string,
        lastName: string,
        leadNotification: any,
        caseNotification: any,
        notificationTime: any,
        passwordResetLink: string
    };
    dealerId: {
        id: string,
        superDealerCode: string,
        name: string,
        globalCode: string,
        localCode: string,
        regionCode: string,
        countryCode: string
    };
    dateEntered: any;
    createdBy: {
        id: number,
        userName: string,
        firstName: string,
        lastName: string,
        leadNotification: any,
        caseNotification: any,
        notificationTime: any,
        passwordResetLink: string
    };
    dateModified: any;

    addressId: {
        id: number,
        address1: string,
        address2: string,
        address3: string,
        address4: string,
        city: string,
        postalCode: number,
        stateId: {
            id: number,
            stateCode: null,
            name: null
        },
        countryId: {
            id: number,
            code: null,
            name: null
        }
    };
    vin: string;
    vehicles: [
        {
            id: number,
            sugarVKey: null,
            individualId: null,
            vin: string,
            purchaseDate: Date,
            warrantyDate: Date,
            transactionType: string,
            cycle: {
                id: number,
                code: string,
                description: string,
                active: true
            },
            salesType: {
                id: number,
                code: string,
                description: null,
                active: null
            },
            vehicleType: {
                id: number,
                make: string,
                model: string
            },
            year: number,
            dateEntered: Date,
            createdBy: null,
            dateModified: null,
            modifiedBy: null,
            deleted: null,
            dateSynced: null
        }
    ];


    constructor(id: number,
    companyName:string,
        firstName: string,
        lastName: string,
        phone: string,
        phoneTimeToCall: string,
        mobile: string,
        mobileTimeToCall: string,
        email: string,
        optedIn: string,
        deleted: boolean,
        userId: number,
        isChangedOwnerShip: boolean,
        assignedTo: any,
        dealerId: any,
        dateEntered: Date,
        createdBy: any,
        dateModified: any,
        addressId: any,
        vin: any,
        vehicles: any
    ) {
        this.id = id,
        this.companyName= companyName,
            this.firstName = firstName,
            this.lastName = lastName,
            this.phone = phone,
            this.phoneTimeToCall = phoneTimeToCall,
            this.mobile = mobile,
            this.mobileTimeToCall = mobileTimeToCall,
            this.email = email,
            this.optedIn = optedIn,
            this.deleted = deleted,
            this.userId = userId,
            this.isChangedOwnerShip = isChangedOwnerShip,
            this.assignedTo = assignedTo,
            this.dealerId = dealerId,
            this.dateEntered = dateEntered,
            this.createdBy = createdBy,
            this.dateModified = dateModified,
            this.addressId = addressId,
            this.vehicles = vehicles,
            this.vin = vin
    }
}


export class OwnershipTracking {
 id:number;
  mod_method: string;

  user_email: string;

  vin: string;

  date_of_change: string;

  prev_first_name: string;

  prev_last_name: string;

  prev_business_name: string;

  prev_email: string;

  prev_home_phone: string;

  prev_mobile_phone: string;

  prev_purchase_date: string;

  prev_sale_type_code: string;

  prev_owner_dealer_code: string;

  new_first_name: string;

  new_last_name: string;

  new_business_name: string;

  new_email: string;

  new_home_phone: string;

  new_mobile_phone: string;

  new_purchase_date: string;

  new_sale_type_code: string;

  new_owner_dealer_code: string;
}



export class OwnersAdvanceSearch {
    lastName = "";
    userId = 0;
    countryIds: any= [];
    salesTypeIds: any = [];
    ownershipStatusList: any= [];
    vin:any= "";
    dealerIds: any= [];
    fromPurchaseDate : string;
    toPruchaseDate : string;
    offset = 0;
    pageLimit:number;
    isPagination = true;
    orderBy="";
    sortBy="";

    firstName =""
    regionIds:any =[]
    isExact:boolean = false
    constructor(lastName: string, countryIds:any, userId: number, salesTypeIds:any, ownershipStatusList:any, vin: any, dealerIds: any, fromPurchaseDate: string, toPruchaseDate: string, offset: number, pageLimit: number, isPagination: boolean,orderBy:string,sortBy:string,firstName:string,regionIds:any,isExact:boolean) {
        this.lastName = lastName;
        this.countryIds = countryIds;
        this.userId = userId;
        this.salesTypeIds = salesTypeIds;
        this.ownershipStatusList = ownershipStatusList;
        this.vin = vin;
        this.dealerIds = dealerIds;
        this.fromPurchaseDate = fromPurchaseDate;
        this.offset = offset;
        this.pageLimit = pageLimit;
        this.toPruchaseDate = toPruchaseDate;
        this.isPagination = isPagination;
        this.orderBy = orderBy;
        this.sortBy = sortBy;
        this.firstName = firstName;
        this.regionIds = regionIds;
        this.isExact = isExact
    }
}





// WEBPACK FOOTER //
// ./src/app/modules/owners/models/data-model.ts